import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectIsApartment = createSelector(selectJsonQuery, jsonQuery => getTermValue('apartment')(jsonQuery));
